export default __webpack_public_path__ + "img/bang.1afbb26d.svg";